var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('a',{attrs:{"href":_vm.href,"target":_vm.value.external ? '_blank' : ''}},[(_vm.slot)?[_vm._t("default")]:[_vm._v(" "+_vm._s(_vm.value.name)+" ")]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }